import { useRef } from 'react';

import isEqual from 'lodash/isEqual';

import type { Optional, Nullable } from '@shared/types/utils';

import FetchDataSource from '@shared/data-access-frontend/fetch-data-source';

type DataSourceConfig<T> = {
  initialData: T[];
  onFetchFailed: (error: Error) => void;
  fetchData: (offset: number) => Promise<Optional<T[]>>;
};

const useDataSource = <T>({
  fetchData,
  initialData,
  onFetchFailed,
}: DataSourceConfig<T>) => {
  const dataSourceRef = useRef<Nullable<FetchDataSource>>(null);

  if (
    dataSourceRef.current?.elements &&
    isEqual(dataSourceRef.current.elements, initialData)
  ) {
    return dataSourceRef.current;
  }

  dataSourceRef.current = new FetchDataSource(
    fetchData,
    onFetchFailed,
    initialData,
  );

  return dataSourceRef.current;
};

export default useDataSource;
